import type { TFunction } from "i18next";
import type { FusionMenuConfig } from "~/components/dock/FusionMenu";

import { ApplicationEnum } from "~/@types/enums";

const createForecastFusionConfig = (t: TFunction<"common">): FusionMenuConfig => ({
	defaultQuickActionKeys: ["forecasting", "sessions"],
	logo: "/logos/forecast.svg",
	module: ApplicationEnum.FORECAST,
	quickActions: [
		{ icon: "table_chart", label: t("dock.quickActionLabels.forecast.forecasting"), pageId: "forecasting" },
		{ icon: "event_note", label: t("dock.quickActionLabels.forecast.sessions"), pageId: "sessions" },
		{ icon: "insights", label: t("dock.quickActionLabels.forecast.dashboard"), pageId: "dashboard" }
	],
	sections: [
		{
			groups: [{ items: [{ icon: "insights", pageId: "dashboard" }] }],
			icon: "insights",
			id: "dashboard",
			label: t("dock.pages.forecast.dashboard")
		},
		{
			groups: [
				{
					items: [
						{ icon: "event_note", label: t("dock.pages.forecast.sessions"), pageId: "sessions" },
						{ icon: "table_chart", label: t("dock.pages.forecast.forecasting"), pageId: "forecasting" },
						{ icon: "calendar_view_week", label: t("dock.pages.forecast.weekly"), pageId: "weekly" },
						{ icon: "tune", label: t("dock.pages.forecast.parameters"), pageId: "parameters" }
					]
				}
			],
			icon: "table_chart",
			id: "planning",
			label: t("dock.pages.forecast.sectionPlanning")
		},
		{
			groups: [
				{
					items: [
						{ icon: "list_alt", label: t("dock.pages.forecast.dataManagementItems"), pageId: "data-management-items" },
						{
							icon: "category",
							label: t("dock.pages.forecast.dataManagementPrograms"),
							pageId: "data-management-programs"
						},
						{
							icon: "location_on",
							label: t("dock.pages.forecast.dataManagementLocations"),
							pageId: "data-management-locations"
						}
					]
				}
			],
			icon: "database",
			id: "data-management",
			label: t("dock.pages.forecast.sectionDataManagement")
		},
		{
			groups: [
				{ items: [{ icon: "rule", label: t("dock.pages.forecast.setupAssumptions"), pageId: "setup-assumptions" }] }
			],
			icon: "tune",
			id: "setup",
			label: t("dock.pages.forecast.sectionSetup")
		},
		{
			groups: [{ items: [{ icon: "settings", pageId: "settings" }] }],
			icon: "settings",
			id: "settings",
			label: t("dock.pages.forecast.settings")
		}
	]
});

export default createForecastFusionConfig;
